import type { JSX } from 'preact';

/**
 * Inline SVG icons for the tab bar.
 *
 * Hand-drawn rather than pulled from an icon package: three glyphs do not justify
 * a dependency in a bundle whose first paint comes from a service worker cache.
 * All are decorative — the tab label carries the accessible name.
 */
function Icon(props: { children: JSX.Element | JSX.Element[] }): JSX.Element {
  return (
    <svg
      class="tab-icon"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      {props.children}
    </svg>
  );
}

export function ScheduleIcon(): JSX.Element {
  return (
    <Icon>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </Icon>
  );
}

export function ClassesIcon(): JSX.Element {
  return (
    <Icon>
      <path d="M4 7h16M4 12h16M4 17h10" />
    </Icon>
  );
}

export function StatsIcon(): JSX.Element {
  return (
    <Icon>
      <path d="M5 20V13M12 20V6M19 20v-4" />
    </Icon>
  );
}

export function MoreIcon(): JSX.Element {
  return (
    <Icon>
      <circle cx="5" cy="12" r="1.4" />
      <circle cx="12" cy="12" r="1.4" />
      <circle cx="19" cy="12" r="1.4" />
    </Icon>
  );
}

export function ChevronRight(): JSX.Element {
  return (
    <svg
      class="chevron"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}
